'use client';

import { ToastBar, Toaster } from 'react-hot-toast';
import { snackbarStateToToastType } from './type';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { Snackbar } from '../snackbar';
const ToastContainer = () => {
  const {
    isMobile
  } = useMobileDetect();
  return <Toaster containerClassName='!z-top-of-chatbot-plus2' containerStyle={{
    top: 80,
    bottom: isMobile ? 16 : 32
  }} toastOptions={{
    className: 'w-full min-w-full lg:w-auto lg:min-w-[328px] lg:max-w-[450px] !p-0 !bg-transparent relative'
  }} position='bottom-center' data-sentry-element="Toaster" data-sentry-component="ToastContainer" data-sentry-source-file="index.tsx">
            {t => <ToastBar toast={t}>
                    {({
        message
      }) => <Snackbar className='w-full [&_div]:!m-0' state={snackbarStateToToastType[t.type]} size={isMobile ? 'medium' : 'large'} style='filled' type='text' hasIcon>
                            {message}
                        </Snackbar>}
                </ToastBar>}
        </Toaster>;
};
export default ToastContainer;